import React, { useState, useEffect, useRef, useCallback } from 'react'

import { SafeAreaView } from 'react-native-safe-area-context'

import {
  StyleSheet,
  View,
  Animated,
  RefreshControl,
  Dimensions,
  ScrollView,
  Platform,
  Text,
  StatusBar,
  BackHandler,
  Alert
} from 'react-native'

import { useFocusEffect } from '@react-navigation/native';

import { messaging } from '../Components'
import { useContent } from '@sart/content'

import client, { useClient } from '@sart/client'
import PrepaidDashboard from './PrepaidDashboard'
import PostpaidDashboard from './PostpaidDashboard'
import BroadbandDashboard from './BroadbandDashboard'
import HomePhoneDashboard from './HomePhoneDashboard'
import MediaDashboard from './MediaDashboard'

import SelectService from './SelectService'

import { adaptive, colors } from '@sart/styles'
import {
  isPrepaidService,
  isPostpaidService,
  isFixedLineService,
  isHomePhoneService,
  isMediaService
} from '@sart/utilities'
import { updateNotifications } from '@sart/utilities'

const SNAP_INTERVAL = Dimensions.get('window').width

export default function DashboardContainer(props) {
  const { navigation, route } = props
  const content = useContent()
  let key = 0
  const syncAccounts = route.params?.syncAccounts
  const [reload, setReload] = useState(false)
  const {
    cache: {
      accounts,
      customerId,
      loading
    } = {}
  } = useClient()

  useEffect(() => {
    updateNotifications(client.cache.userId)
    loadData()
    //SB Commenting this out as we are not launching with push notifications yet
    // registerForPushNotifications()
  }, [])

  useFocusEffect(
    useCallback(() => {
      const onBackPress = () => {
        Alert.alert(
          'Logout',
          'Do you want to logout?',
          [
            {
              text: 'Cancel',
              onPress: () => { },
              style: 'cancel',
            },
            { text: 'YES', onPress: handleLogout },
          ],
          { cancelable: false }
        )

        return true
      }

      const backHandler = BackHandler.addEventListener('hardwareBackPress', onBackPress)

      return () => {
        // cleanup when screen loses focus
        if (backHandler && backHandler.remove) backHandler.remove()
        else BackHandler.removeEventListener('hardwareBackPress', onBackPress)
      }
    }, [])
  )

  const [currentIndex, setCurrentIndex] = useState(0)

  async function handleLogout() {
    try {
      await client.signOutAndForget()
      navigation.popToTop()
      navigation.navigate('Sign', { screen: 'SignIn' })
    } catch (error) {
      console.log(error)
    }
  }

  async function loadData() {
    client.setCache({ loading: true })
    try {
      await client.cacheUserInformation(client.cache.customerId, 'Mobile')
      //SB - we are only wanting to get Mobile services for initial launch
      // await client.cacheUserInformation(client.cache.customerId, 'Fixedline')
      // await client.cacheUserInformation(client.cache.customerId, 'HomePhone')
      // await client.cacheUserInformation(client.cache.customerId, 'Media')

      await client.loadPersonalDetails()
      await client.loadPaymentPreference()
      console.log('Services loaded: ', JSON.stringify(client.cache.services, null, 2))
      console.log('DASHBOARD container = accounts are: ', JSON.stringify(accounts, null, 2))
      client.cache.contextService = client.cache.services[0]
      client.setCache({ loading: false })
    } catch (error) {
      console.log(error)
      client.setCache({ loading: false })
    }
  }

  //TODO This function, or it's contense moved into a separate file probably?
  // I'm just trying to get it to work right now -- Matthew
  async function registerForPushNotifications() {
    // var permission = await messaging().requestPermission()
    // if(permission) {
    //   await messaging().registerDeviceForRemoteMessages()
    //   var registrationId = await messaging().getToken()
    //   var devices = await client.callApi('customer','getDevices',[customerId])
    //   if(!deviceRegistered(devices,registrationId)) {
    //     var device = await client.callApi('customer','createDevice',[customerId])
    //     device.registrationId = registrationId
    //     await client.callApi('customer','modifyDevice',[customerId,device.deviceId,device])
    //   }
    // }

    //REMOVED, DO NOTHING
  }

  //TODO probably should be put into a different file
  function deviceRegistered(devices, registrationId) {
    var isRegistered = false
    for (var i = 0; i < devices.length; i++) {
      if (devices[i].registrationId === registrationId) {
        isRegistered = true
      }
    }
    return isRegistered
  }

  async function reloadAccounts() {
    await client.cacheUserAccountInformation(client.cache.customerId)
    await loadData()
    setReload(!reload)
    await updateNotifications(client.cache.userId)
  }

  const scrollY = new Animated.Value(0)
  const scrollX = useRef(new Animated.Value(0)).current

  function handleScroll(event) {
    var totalWidth = Dimensions.get('window').width
    var xPos = event.nativeEvent.contentOffset.x
    var newCurrentIndex = Math.floor(xPos / totalWidth);
    setCurrentIndex(newCurrentIndex)
    client.setCache({ contextService: client.cache.services[newCurrentIndex] })
  }

  return (
    <SafeAreaView style={{
      paddingTop: Platform.OS === 'android' ? StatusBar.currentHeight : 0
    }}>
      <Animated.ScrollView
        scrollEventThrottle={1}
        // stickyHeaderIndices={[0,]}
        showsVerticalScrollIndicator={true}
        onScroll={
          Animated.event([
            { nativeEvent: { contentOffset: { y: scrollY } } }
          ], {})
        }
        style={styles.container}
        refreshControl={
          <RefreshControl
            refreshing={loading}
            onRefresh={reloadAccounts}
          />
        }
      >
        {accounts !== undefined &&
          <View>
            <Animated.ScrollView
              horizontal
              showsHorizontalScrollIndicator={false}
              snapToInterval={SNAP_INTERVAL}
              decelerationRate="fast"
              style={styles.scrollViewContainer}
              pagingEnabled
              onScroll={Animated.event([{
                nativeEvent: {
                  contentOffset: {
                    x: scrollX
                  }
                }
              }], { listener: (event) => handleScroll(event) })}
              scrollEventThrottle={16}
            >
              {accounts && accounts.map(account => {
                return account.services.map(service => {
                  if (isPostpaidService(service)) {
                    return (<PostpaidDashboard
                      account={account}
                      service={service}
                      navigation={navigation}
                      reloadData={reload}
                      key={key}
                    />)
                  } else if (isPrepaidService(service)) {
                    return (<PrepaidDashboard
                      account={account}
                      service={service}
                      navigation={navigation}
                      reloadData={reload}
                      reloadAccounts={reloadAccounts}
                      recentlyActivated={route.params?.recentlyActivated}
                      key={key}
                    />)
                  } else if (isFixedLineService(service)) {
                    return (<BroadbandDashboard
                      account={account}
                      service={service}
                      navigation={navigation}
                      reloadData={reload}
                      key={key}
                    />)
                  } else if (isHomePhoneService(service)) {
                    return (<HomePhoneDashboard
                      account={account}
                      service={service}
                      navigation={navigation}
                      reloadData={reload}
                      key={key}
                    />)
                  } else if (isMediaService(service)) {
                    return (<MediaDashboard
                      account={account}
                      service={service}
                      navigation={navigation}
                      reloadData={reload}
                      key={key}
                    />)
                  }
                  key++
                })
              }
              )}
              {/*<SelectService navigation={navigation} /> */}
            </Animated.ScrollView>

          </View>
        }
      </Animated.ScrollView>
      {/*SB - Commenting out the dots for now as we are only showing one service at a time
      TODO - put these dots back in when we have multiple services showing at once */}
      {/* <View style={styles.navigationDotsContainer}>
        <View style={styles.navigationDots}>
          {accounts && accounts.map((account, index) => {
            // console.log('index is: ' + index);
            return (
              <View style={index === currentIndex ? styles.activeDot : styles.inactiveDot} />
            )
          })}
        </View>
      </View> */}
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    // flex: 1,
    // backgroundColor: 'plum'
  },
  scrollViewContainer: {
    ...Platform.select({
      android: {
      },
      ios: {
        height: Dimensions.get('screen').height - 80,
      },
      web: {

      }
    }),
  },
  navigationDotsContainer: {
    width: '100%',
    backgroundColor: colors.darkCharcoal,
    position: 'absolute',
    bottom: 0,
  },
  navigationDots: {
    width: 100,
    height: 30,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignSelf: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  inactiveDot: {
    height: 15,
    width: 15,
    borderRadius: 15,
    borderWidth: 2,
    backgroundColor: colors.white,
    borderColor: colors.srGreen
  },
  activeDot: {
    height: 15,
    width: 15,
    borderRadius: 15,
    borderWidth: 2,
    backgroundColor: colors.srGreen,
    borderColor: colors.srGreen
  }
})
